/**

 * JS per a la vista "product"

 */

import producteNavegacioColors from '../components/producte-navegacio-colors';

import cartService from '../services/cart.service';

import axios from 'axios';



/* S'assumeix que el jQuery està carregat */

const $ = window.jQuery;



/**

 * Aquesta és la funció que inicialitza tot i que es crida quan

 * es carrega el document.

 */

$(function () {

    console.log('Document ready - Buscando botón add-to-babylist');
    const babylistButton = document.querySelector('#button-add-to-babylist');
    console.log('Botón encontrado en document ready:', !!babylistButton);

    console.log('Initial form HTML:', document.querySelector('#form-add-to-babylist')?.outerHTML);

    /* Fancybox per a les imatges */

    //https://codepen.io/fancyapps/pen/GxBpYY

    $('[data-fancybox="images"]').fancybox({

        buttons: [

            "close"

        ],

        thumbs : {

            autoStart : true,

            axis      : 'x'

        },

        afterLoad: function () {

            /* Dunno why but it gets fired twice, so I set a var in fancybox

             * container to run code here just once. */

            const jqFancyboxContainer = $('.fancybox-container');

            if (!jqFancyboxContainer.data('already-loaded')) {

                jqFancyboxContainer.data('already-loaded', 1);

                jqFancyboxContainer.find('.fancybox-button--arrow_left').on('click', function () {



                });

                jqFancyboxContainer.find('.fancybox-button--arrow_right').on('click', function () {



                });

            }

        },

    });



    /* Despleagble go to top */

    $('.accordion-button').click(function(){

        const stickyHeight = $('#menusticky').height();

        var goto=$(this).attr("aria-controls");

        var gotopt="."+goto;

        setTimeout(function () {

            if ($(gotopt).offset().top - $(window).scrollTop() < stickyHeight) {

                $([document.documentElement, document.body]).animate({

                    scrollTop: $(gotopt).offset().top - stickyHeight,

                }, 0);

            }

        }, 400);

    });



    /* go to Más info */

    $('.btmoreinfo').click(function(){

        const stickyHeightMore = $('#menusticky').height();

        //alert(stickyHeightMore +'ffvoy');

        //id="moreinfo"

       /* var goto=$(this).attr("aria-controls");

        var gotopt="."+goto;*/

        //setTimeout(function () {

           // if ($("#moreinfo").offset().top - $(window).scrollTop() < stickyHeightMore) {

                $([document.documentElement, document.body]).animate({

                    scrollTop: $("#moreinfo").offset().top - stickyHeightMore,

                }, 0);

           //}

        //}, 0);

    });



    /* Navegacio colors */

    navegacioColors();



    /* Afegir al carrito */

    $('#button-add-to-basket').on('click', function (event) {
        event.preventDefault();
        const jqBt = $(this);
        jqBt.css('opacity', 0.5);
        jqBt.css('pointer-events', 'none');
        const idProducte = producteNavegacioColors.getIdProducte();
        const activeColorIds = producteNavegacioColors.getActiveColorIds();
        let personalizacion = '';
        if (jqBt.data('is-personalitzable')) {
            const textPersonalitzacio = getPromptPersonalitzacioText(
                jqBt.data('personalitzable-message'),
                jqBt.data('personalitzable-length-error-message'));
            if (textPersonalitzacio !== null) {
                personalizacion = textPersonalitzacio;
            } else {
                return;
            }
        }
        if (idProducte && activeColorIds.length > 0) {
            cartService.addArticle(idProducte, activeColorIds, 1, personalizacion)
                .finally(() => {
                    jqBt.css('opacity', 1);
                    jqBt.css('pointer-events', 'auto');

                    setTimeout(() => {
                        let $nodoOriginal = $("#productos-recomendados");
                        let $nodoClonado = $nodoOriginal.clone(true, true);

                        // Extraer los items del producto del owl carousel
                        let $items = $nodoClonado.find('.owl-carousel .owl-item:not(.cloned) .item-product').detach();

                        // Limpiar la estructura del owl carousel
                        $nodoClonado.find('.owl-carousel').remove();

                        // Crear nuevo contenedor para los productos con grid 3x3
                        let $newContainer = $('<div class="recommended-products-grid"></div>').css({
                            'display': 'grid',
                            'grid-template-columns': 'repeat(3, 1fr)',
                            'gap': '4px',
                            'padding': '0px',
                            'margin': '0 auto'
                        });

                        // Ajustar los items y las imágenes
                        $items.css({
                            'width': '100%',
                            'margin': '0'
                        }).each(function() {
                            // Ajustar el tamaño de las imágenes
                            $(this).find('.item-product__img').css({
                                'width': '107px',
                                'height': '100px',
                                'background-size': 'cover',
                                'background-position': 'center',
                                'margin': '0 auto'
                            });

                            // Limitar a 9 items (grid 3x3)
                            if ($newContainer.children().length < 9) {
                                $(this).appendTo($newContainer);
                            }
                        });

                        // Insertar el nuevo contenedor en la estructura
                        $nodoClonado.find('.row.newcomers').append($newContainer);

                        // Ajustar el título para que coincida con el nuevo diseño
                        $nodoClonado.find('.h2-title').css({
                            'font-size': '16px',
                            'margin-bottom': '15px'
                        });

                        // Añadir al contenedor del carrito
                        let $contenedor = $("#productos-recomendados-cart");
                        $contenedor.empty().append($nodoClonado);
                    }, 1000);
                });
        }
    });

    $('#button-add-to-basket-sticky').on('click', function () {
        $('#button-add-to-basket').click();
    });

    /* Afegir a la babylist */

    initBabylistButton();

    $('#button-add-to-babylist-sticky').on('click', function () {
        $('#button-add-to-babylist').click();
    });

    $('.color-plus').click(function () {
        const backgroundImage = document.querySelector(".product-slider .slide-item").style.backgroundImage;
        document.querySelector("#first_image_popup").src = backgroundImage.slice(5, -2);
        $('#color-selector-popup').show();
        $('html').addClass('side-open');
    });

    // Modificar el evento click del botón
    $(document).on('click', '#open-color-selector-popup', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $button = $(this);
        const productId = $button.data('id_producte');
        const $popup = $('#color-selector-popup');

        // Obtener la imagen actual con comprobación de existencia
        const firstSlideItem = document.querySelector(".product-slider .slide-item");
        let imageUrl = '';

        if (firstSlideItem && firstSlideItem.style && firstSlideItem.style.backgroundImage) {
            imageUrl = firstSlideItem.style.backgroundImage.slice(5, -2);
        } else {
            const firstProductImage = document.querySelector('#product-images-wrapper img');
            if (firstProductImage) {
                imageUrl = firstProductImage.src;
            }
        }

        // Actualizar la imagen del popup si existe el elemento
        const popupImage = document.querySelector("#first_image_popup");
        if (popupImage && imageUrl) {
            popupImage.src = imageUrl;
        }

        // Mostrar el popup
        $popup.show();
        $('html').addClass('side-open');

        // Mostrar solo los colores del producto seleccionado
        if (productId) {
            $popup.find('.colors-info-producte').each(function() {
                const $this = $(this);
                if ($this.data('id_producte') === productId) {
                    $this.show();
                } else {
                    $this.hide();
                }
            });
        }
    });

    // Función para cerrar el selector de color
    function closeColorSelector() {
        const $popup = $('#color-selector-popup');
        $popup.hide();
        $('html').removeClass('side-open');
    }

    $(document).ready(function() {
        // Cerrar con el botón X
        $('.color-plus-close').on('click', function() {
            closeColorSelector();
        });

        // Cerrar al hacer clic fuera del drawer
        $('#color-selector-popup').on('click', function(e) {
            if ($(e.target).is(this)) {
                closeColorSelector();
            }
        });

        // Cerrar al hacer clic en "Listo"
        $('.color-selector-done').on('click', function() {
            closeColorSelector();
        });

        // Prevenir que los clicks dentro del drawer lo cierren
        $('.color-selector-popup-inner').on('click', function(e) {
            e.stopPropagation();
        });

        // Al seleccionar un color en el popup
        $(document).on('click', '#color-selector-popup .colors__bt', function(e) {
            e.stopPropagation();
            // No cerramos el drawer aquí, solo actualizamos el color
        });

        // Función para debounce simple
        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        // Función para ajustar las partes personalizables visibles en la sticky bar
        function adjustVisiblePersonalizations() {
            const $stickyBar = $('.sticky-product-bar');
            const $colorContainer = $stickyBar.find('.colors-container');
            const $colorGroups = $colorContainer.find('.colors__product[data-sticky-colors]');
            const $moreLink = $colorContainer.find('.more-personalizations-link');
            const screenWidth = window.innerWidth;

            // Obtener el total real desde el data attribute
            const actualTotalParts = parseInt($colorContainer.data('total-personalizables'));
            console.log('Total partes real desde PHP:', actualTotalParts);

            // Determinar cuántas partes mostrar según el ancho de pantalla
            let visibleParts;
            if (screenWidth <= 375) {
                visibleParts = 1;
            } else if (screenWidth <= 576) {
                visibleParts = 2;
            } else {
                visibleParts = 3;
            }
            console.log('Partes visibles según pantalla:', visibleParts);

            // Ocultar las partes excedentes y actualizar el contador
            if (actualTotalParts > visibleParts) {
                $colorGroups.show(); // Mostrar todos primero
                $colorGroups.slice(visibleParts).hide(); // Ocultar los excedentes

                // Actualizar el contador en el enlace existente
                const remainingParts = actualTotalParts - visibleParts;
                console.log('Partes restantes calculadas:', remainingParts);

                if ($moreLink.length) {
                    $moreLink.text(`+${remainingParts} personalizaciones`);
                    console.log('Texto actualizado en moreLink:', $moreLink.text());
                }
            }
        }

        // Ejecutar al cargar y al cambiar el tamaño de la ventana
        adjustVisiblePersonalizations();
        $(window).on('resize', debounce(adjustVisiblePersonalizations, 150));

        // Cuando se selecciona un nuevo color
        $('.sticky-product-bar .colors__bt').click(function() {
            setTimeout(adjustVisiblePersonalizations, 100);
        });

        // En la función que maneja la sincronización de colores
        $('.colors__product:not([data-sticky-colors]) .colors__bt').click(function() {
            const colorId = $(this).data('id_producte_color');
            const stickyColorGroup = $(this).closest('.colors__product').data('id_producte');
            const colorName = $(this).data('nom');

            // Limpiar primero todos los colores en la sticky bar
            $(`.sticky-product-bar .colors__product[data-id_producte="${stickyColorGroup}"] .colors__bt`).remove();

            // Añadir solo el color seleccionado
            const $stickyColorContainer = $(`.sticky-product-bar .colors__product[data-id_producte="${stickyColorGroup}"]`);
            const $colorClone = $(this).clone();
            $colorClone.addClass('colors__bt__select');
            $stickyColorContainer.append($colorClone);

            // Actualizar el texto del color en la sticky bar
            $(`.sticky-product-bar .colors__product[data-id_producte="${stickyColorGroup}"] .producte-color-etiqueta`)
                .text(colorName);

            // Actualizar el selector en el contenido principal
            $(`.colors__product[data-id_producte="${stickyColorGroup}"]:not([data-sticky-colors]) .colors__bt`)
                .removeClass('colors__bt__select');
            $(`.colors__product[data-id_producte="${stickyColorGroup}"]:not([data-sticky-colors]) .colors__bt[data-id_producte_color="${colorId}"]`)
                .addClass('colors__bt__select');
        });

        // Manejar colores iniciales desde hash
        const colorIds = getColorIdsFromHash();
        if (colorIds) {
            producteNavegacioColors.setActiveColorIds(colorIds);
            // Esperar a que se actualicen los colores antes de inicializar la sticky
            setTimeout(initializeStickyColors, 100);
        } else {
            initializeStickyColors();
        }

        // Actualizar la sticky bar cuando cambian los colores
        producteNavegacioColors.addEventListener(
            producteNavegacioColors.EVENT_COLOR_CHANGE,
            function() {
                initializeStickyColors();
            }
        );

        // Scroll suave al hacer click en "+X personalizaciones"
        $('.more-personalizations-link').click(function(e) {
            e.preventDefault();
            const $colorsSection = $('.colors-info-producte-wrapper').first();
            const offset = $colorsSection.offset().top - 100; // Ajustar el offset según necesites

            $('html, body').animate({
                scrollTop: offset
            }, 500);

            // Opcional: Abrir el popup de colores si existe
            if ($('#color-selector-popup').length) {
                $('#color-selector-popup').show();
                $('html').addClass('side-open');
            }
        });

        // Función para truncar textos en la sticky bar
        truncateStickyTexts();
        $(window).on('resize', debounce(truncateStickyTexts, 150));

        // Función para manejar la visibilidad del precio tachado en sticky bar
        handleStickyPricePrevVisibility();
        $(window).on('resize', debounce(handleStickyPricePrevVisibility, 150));

        // Función para manejar la visibilidad de la sticky bar según el footer
        function handleStickyBarFooterIntersection() {
            const $stickyBar = $('.sticky-product-bar');
            const $footer = $('.footer');

            if (!$stickyBar.length || !$footer.length) return;

            const footerTop = $footer.offset().top;
            const scrollPosition = $(window).scrollTop() + $(window).height();
            const stickyBarHeight = $stickyBar.outerHeight();

            // Si el scroll llega al footer, ocultamos la sticky bar
            if (scrollPosition > footerTop) {
                $stickyBar.css({
                    'opacity': '0',
                    'visibility': 'hidden',
                    'transform': 'translateY(100%)',
                    'transition': 'all 0.3s ease-in-out'
                });
                // Eliminar el margen cuando la barra está oculta
                $('body').css('margin-bottom', '0');
            } else {
                $stickyBar.css({
                    'opacity': '1',
                    'visibility': 'visible',
                    'transform': 'translateY(0)',
                    'transition': 'all 0.3s ease-in-out'
                });
                // Restaurar el margen cuando la barra es visible
                $('body').css('margin-bottom', stickyBarHeight + 'px');
            }
        }

        // Establecer CSS inicial para la sticky bar
        const $stickyBar = $('.sticky-product-bar');
        $stickyBar.css({
            'position': 'fixed',
            'bottom': '0',
            'left': '0',
            'right': '0',
            'z-index': '1000',
            'transition': 'all 0.3s ease-in-out'
        });

        // Ejecutar al cargar y al hacer scroll
        handleStickyBarFooterIntersection();
        $(window).on('scroll', debounce(handleStickyBarFooterIntersection, 10));

        // Ejecutar también al cambiar el tamaño de la ventana
        $(window).on('resize', debounce(handleStickyBarFooterIntersection, 150));

        // Función para truncar textos en la sticky bar
        function truncateStickyTexts() {
            const screenWidth = window.innerWidth;
            const titleMaxLength = 20;
            const labelMaxLength = 10;

            // Función helper para truncar texto
            function truncateText(text, maxLength) {
                return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
            }

            // Truncar título del producto
            const $stickyTitle = $('.sticky-product-bar__details h3');
            $stickyTitle.each(function() {
                const $title = $(this);
                const originalText = $title.data('original-text') || $title.text();

                // Guardar el texto original si no lo hemos guardado antes
                if (!$title.data('original-text')) {
                    $title.data('original-text', originalText);
                }

                if (screenWidth <= 576) { // Mobile
                    $title.text(truncateText(originalText, titleMaxLength));
                } else {
                    // Restaurar texto original en desktop
                    $title.text(originalText);
                }
            });

            // Truncar etiqueta de color
            const $colorLabel = $('.sticky-product-bar__details .producte-color-etiqueta');
            $colorLabel.each(function() {
                const $label = $(this);
                const originalText = $label.data('original-text') || $label.text();

                // Guardar el texto original si no lo hemos guardado antes
                if (!$label.data('original-text')) {
                    $label.data('original-text', originalText);
                }

                if (screenWidth <= 576) { // Mobile
                    $label.text(truncateText(originalText, labelMaxLength));
                } else {
                    // Restaurar texto original en desktop
                    $label.text(originalText);
                }
            });
        }

        // Función para añadir botones de zoom
        function addZoomButtonToSlides() {
            if (window.innerWidth >= 768) { // Solo en desktop
                $('.product-slider .slide-item').each(function() {
                    const $slide = $(this);
                    // Solo añadir si no existe ya
                    if (!$slide.find('.zoom-button').length) {
                        const $zoomButton = $(`
                            <button type="button" class="zoom-button">
                                <img src="/images/icons/zoom-arrow.png" alt="zoom">
                            </button>
                        `);

                        // Añadir el botón
                        $slide.append($zoomButton);

                        // Añadir el evento click
                        $zoomButton.on('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            // Encontrar y hacer click en el enlace fancybox correspondiente
                            $slide.closest('.slide-item').find('[data-fancybox="images"]').trigger('click');
                        });
                    }
                });
            }
        }

        // Llamar cuando se inicializa el carousel
        $('.owl-carousel').on('initialized.owl.carousel', function() {
            addZoomButtonToSlides();
        });

        // Llamar cuando cambia el slide
        $('.owl-carousel').on('translated.owl.carousel', function() {
            addZoomButtonToSlides();
        });

        // Actualizar en resize
        $(window).on('resize', debounce(addZoomButtonToSlides, 150));

        // Actualizar cuando se recargan las imágenes
        producteNavegacioColors.addEventListener(
            producteNavegacioColors.EVENT_IMAGES_RELOADED,
            function() {
                setTimeout(addZoomButtonToSlides, 100); // Pequeño delay para asegurar que las imágenes están cargadas
            }
        );

        // Llamada inicial
        addZoomButtonToSlides();

        // Añadir funcionalidad al botón de cierre
        $('.btn-close-sticky').on('click', function() {
            const $stickyBar = $('.sticky-product-bar');
            $stickyBar.removeClass('visible');
            $stickyBar.css({
                'opacity': '0',
                'visibility': 'hidden',
                'transform': 'translateY(100%)'
            });
            // Eliminar el margen cuando la barra está oculta
            $('body').css('margin-bottom', '0');
        });

        // Función para aplicar estilos al carousel en móvil
        function applyMobileCarouselStyles() {
            const $productImagesCarousel = $('#product-images-wrapper .owl-carousel');
            
            if (window.innerWidth <= 575) {
                // Aplicar padding a la galería usando attr('style')
                $('.col-12.col-md-7.gallery-outer.order-15.ps-md-4.pe-md-4.px-4')
                    .attr('style', 'padding-right: 0px !important');

                // Aplicar margen solo al carrusel de imágenes del producto
                $productImagesCarousel.find('.owl-item.active').css('margin-right', '5px');

                // Mantener las alturas controladas solo para el carrusel de imágenes
                $productImagesCarousel.find('.owl-stage').css({
                    'display': 'flex',
                    'align-items': 'center'
                });

                $productImagesCarousel.find('.owl-item').css({
                    'height': '100%',
                    'display': 'flex',
                    'align-items': 'center'
                });
            } else {
                // Restaurar estilos originales solo para el carrusel de imágenes
                $('.col-12.col-md-7.gallery-outer.order-15.ps-md-4.pe-md-4.px-4')
                    .attr('style', '');
                $productImagesCarousel.find('.owl-item.active').css('margin-right', '');
                $productImagesCarousel.find('.owl-stage, .owl-item').css({
                    'display': '',
                    'align-items': '',
                    'height': ''
                });
            }
        }

        // Aplicar los estilos solo después de que el carousel de imágenes esté inicializado
        $('#product-images-wrapper .owl-carousel').on('initialized.owl.carousel', function() {
            setTimeout(applyMobileCarouselStyles, 100);
        });

        // Reajustar cuando cambie el tamaño de la ventana
        $(window).on('resize', debounce(applyMobileCarouselStyles, 150));

        // Aplicar también cuando el carousel de imágenes se mueva
        $('#product-images-wrapper .owl-carousel').on('translated.owl.carousel', function() {
            applyMobileCarouselStyles();
        });

        // Llamada inicial
        applyMobileCarouselStyles();
    });

    // Función para truncar textos en la sticky bar
    function truncateStickyTexts() {
        const screenWidth = window.innerWidth;
        const titleMaxLength = 20;
        const labelMaxLength = 10;

        // Función helper para truncar texto
        function truncateText(text, maxLength) {
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        }

        // Truncar título del producto
        const $stickyTitle = $('.sticky-product-bar__details h3');
        $stickyTitle.each(function() {
            const $title = $(this);
            const originalText = $title.data('original-text') || $title.text();

            // Guardar el texto original si no lo hemos guardado antes
            if (!$title.data('original-text')) {
                $title.data('original-text', originalText);
            }

            if (screenWidth <= 576) { // Mobile
                $title.text(truncateText(originalText, titleMaxLength));
            } else {
                // Restaurar texto original en desktop
                $title.text(originalText);
            }
        });

        // Truncar etiqueta de color
        const $colorLabel = $('.sticky-product-bar__details .producte-color-etiqueta');
        $colorLabel.each(function() {
            const $label = $(this);
            const originalText = $label.data('original-text') || $label.text();

            // Guardar el texto original si no lo hemos guardado antes
            if (!$label.data('original-text')) {
                $label.data('original-text', originalText);
            }

            if (screenWidth <= 576) { // Mobile
                $label.text(truncateText(originalText, labelMaxLength));
            } else {
                // Restaurar texto original en desktop
                $label.text(originalText);
            }
        });
    }
});



/**

 * Navegacio colors

 * Els links de personalització han de ser de l'estil:

 * <a href="javascript:" class="product-customizer-link"

 *   data-customizer-url="url-del-customizer"

 *   data-tag-manager-label="slug-del-producte">

 */

function navegacioColors ()

{

    /* Elements jQuery */

    const $productCustomizerLinks = $('.product-customizer-link');

    const $colorsInfoProducte = $('.colors-info-producte');



    /* Datas from elemeents */

    const customizerUrl = $productCustomizerLinks.data('customizer-url');

    const tagManagerLabel = $productCustomizerLinks.data('tag-manager-label');



    /* Constants */

    const fancyboxOptions = {

        type: 'iframe',

        afterLoad: function () {

            $('body').find('.fancybox-container').css({"top": "127px"});

            $('body').find('.fancybox-container').css({"height": "calc(100% - 127px)"});

            $('body').find('.fancybox-slide').css({"padding": "0px"});

            $('body').find('.fancybox-button').css({"background": "#fff"});

            $('body').find('.fancybox-button').css({"color": "#000"});

            $('body').find('.fancybox-button--close').on('click', function () {



            });

        },

        iframe: {

            css: {

                width: '100%',

                height : '100%'

            },

            // Iframe tag attributes

            attr: {

                scrolling: "auto"

            }

        },

    };



    /* Activar el fancybox per al customizer per a tots els links */

    $productCustomizerLinks.fancybox(fancyboxOptions);



    /* Actualitzar els links del botó d'obrir el customizer quan canvia

     * la selecció de colors. */

    function updateProductCustomizerLinks () {
        const query = {
            id_producte: producteNavegacioColors.getIdProducte(),
            'ids_colors_actius': producteNavegacioColors.getActiveColorIds(),
        };

        const searchParams = new URLSearchParams(query);
        $productCustomizerLinks.attr('href', customizerUrl + '?' +
            searchParams.toString());
    }



    /* Actualitza els esdeveniments per a cridar el dataLayer.push() del Tag Manger */

    function updateTagManagerEvents ()
    {
        /* Click en imágenes o vídeo (media) */
        setTimeout(function () {
            $('.tag-manager-product-media-click').each(function ()
            {
                var imageEl = this;
                $(imageEl).on('click', tagManagerImagesClickHandler);
            });
        }, 100);

        /* Click en prev/next en mobile, quan les fotos són un Owl Carousel */
        setTimeout(function () {
            $('.owl-carousel-imgsprod .owl-prev, .owl-carousel-imgsprod .owl-next').each(function ()
            {
                var arrowEl = this;
                $(arrowEl).on('click', tagManagerArrowClickHandler);
            });
        }, 100);
    }

    producteNavegacioColors.addEventListener(

        producteNavegacioColors.EVENT_COLOR_CHANGE,

        (event) => { updateProductCustomizerLinks(); });

    producteNavegacioColors.addEventListener(

        producteNavegacioColors.EVENT_IMAGES_RELOADED,

        (event) => { updateTagManagerEvents(); });

    producteNavegacioColors.init();

    /* Actualitzacions inicials que no s'han fet server side */

    if (customizerUrl) {
        updateProductCustomizerLinks();
    }
    updateTagManagerEvents();
    producteNavegacioColors.updateColorsNavigation();

    /* Crear referències globals per a ser cridada des del iframe. */
    window.producteNavegacioColors = producteNavegacioColors;
    window.productCustomizerCloseFancybox = function () {
        $.fancybox.getInstance($productCustomizerLinks).close();
    };

    /* Activem elements inactius */

    $productCustomizerLinks.removeClass('disabled-at-init');
    $colorsInfoProducte.removeClass('disabled-at-init');

    /* Canviar al color init del has, si n'hi ha */

    const colorIds = getColorIdsFromHash();

    if (colorIds) {
        producteNavegacioColors.setActiveColorIds(colorIds);
    }

    /* Tag manager handlers */
    function tagManagerImagesClickHandler (eventObject)
    {
    }
    function tagManagerArrowClickHandler (eventObject)
    {
    }
}

/* Obtenir init colors del hash i de pas treure el hash de la URL */
function getColorIdsFromHash() {
    const match = document.location.hash.match('#init-color-([0-9\-]+)');
    if (match) {
        history.replaceState(null, '', document.location.href.replace(document.location.hash, ''));
        return match[1].split('-').map(colorId => parseInt(colorId));
    }
    return null;
}

/* Personalitzable */

function getPromptPersonalitzacioText (message, lengthErrorMessage)
{

    let text = '';
    while (text === '' || text.length > 14) {
        text = prompt(message, text);
        if (text === null) {
            break;
        } else if (text.length > 14) {
            alert(lengthErrorMessage);
        }
    }
    return text;
}

// Validación de email en tiempo real
function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && !email.startsWith(' ');
}

function setupEmailValidation(inputElement, submitButton) {
    const input = $(inputElement);
    const button = $(submitButton);
    const exampleText = input.next('.text-xs');

    // Deshabilitar el botón inicialmente
    button.prop('disabled', true);

    input.on('input', function() {
        const email = input.val().trim();
        const isValid = validateEmail(email);

        if (email === '') {
            input.removeClass('is-valid is-invalid');
            exampleText.text('Ej: name@domain.com').removeClass('text-danger');
        } else if (isValid) {
            input.removeClass('is-invalid').addClass('is-valid');
            exampleText.text('Ej: name@domain.com').removeClass('text-danger');
            button.prop('disabled', false);
        } else {
            input.removeClass('is-valid').addClass('is-invalid');
            exampleText.text('Por favor, introduce un email válido').addClass('text-danger');
            button.prop('disabled', true);
        }
    });
}

$(document).ready(function() {
    // Aplicar validación a ambos formularios
    setupEmailValidation(
        '.consulta-plazo-entrega-popup-inner #notify-email',
        '.consulta-plazo-entrega-popup-inner .btn-submit'
    );

    setupEmailValidation(
        '.aviso-disponibilidad-popup-inner #notify-email',
        '.aviso-disponibilidad-popup-inner .btn-submit'
    );

    // Manejo de los popups de información
    function closePopup(popupId) {
        $(popupId).hide();
        $('html').removeClass('side-open');
    }

    // Cerrar con el botón X
    $('.product-info-plus-close').on('click', function() {
        const popup = $(this).closest('[id$="-selector-popup"]');
        closePopup('#' + popup.attr('id'));
    });

    // Click fuera del popup inner
    $('[id$="-selector-popup"]').on('click', function(event) {
        if ($(event.target).is($(this))) {
            closePopup('#' + $(this).attr('id'));
        }
    });

    // Prevenir que los clicks dentro del popup inner cierren el popup
    $('.product-info-selector-popup-inner').on('click', function(event) {
        event.stopPropagation();
    });

    // Abrir popup al hacer click en los botones del accordion
    $('.accordion-button').on('click', function() {
        const popupId = $(this).closest('.accordion-item')
            .find('[id$="-selector-popup"]')
            .attr('id');

        if (popupId) {
            $('#' + popupId).show();
            $('html').addClass('side-open');
        }
    });

    // Manejar la tecla ESC
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('#color-selector-popup').is(':visible')) {
            closeColorSelector();
        }
    });
});

// Función para manejar la visibilidad del precio tachado en sticky bar
function handleStickyPricePrevVisibility() {
    const $stickyPricePrev = $('.sticky-product-bar__actions .sticky-product-bar__price #product-price-prev-sticky');
    const screenWidth = window.innerWidth;

    if (screenWidth <= 470) {
        $stickyPricePrev.hide();
    } else {
        $stickyPricePrev.show();
    }
}

// Modificar la función initializeStickyColors
function initializeStickyColors() {
    // Primero limpiar todos los colores en la sticky bar
    $('.sticky-product-bar .colors__product').each(function() {
        $(this).find('.colors__bt').not('.colors__bt__select').remove();
    });

    // Luego añadir solo los colores seleccionados
    $('.colors__product:not([data-sticky-colors]) .colors__bt.colors__bt__select').each(function() {
        const $selectedColor = $(this);
        const stickyColorGroup = $selectedColor.closest('.colors__product').data('id_producte');
        const colorName = $selectedColor.data('nom');

        // Asegurarse de que no haya duplicados en la sticky
        const $stickyContainer = $(`.sticky-product-bar .colors__product[data-id_producte="${stickyColorGroup}"]`);
        $stickyContainer.find('.colors__bt').remove();

        // Añadir el color seleccionado
        const $colorClone = $selectedColor.clone();
        $colorClone.addClass('colors__bt__select');
        $stickyContainer.append($colorClone);

        // Actualizar el texto del color
        $stickyContainer.find('.producte-color-etiqueta').text(colorName);
    });
}

// Extraer la función del handler
function initBabylistButton() {
    $('#button-add-to-babylist').on('click', function (event) {
        console.log('Click en botón add-to-babylist desde product.js');
        event.preventDefault();
        const jqBt = $(this);
        const form = $('#form-add-to-babylist');
        console.log('Form encontrado:', form.length > 0);
        console.log('Datos del botón:', {
            isPersonalizable: jqBt.data('is-personalitzable'),
            message: jqBt.data('personalitzable-message'),
            errorMessage: jqBt.data('personalitzable-length-error-message')
        });

        jqBt.css('opacity', 0.5);
        jqBt.css('pointer-events', 'none');

        const idProducte = producteNavegacioColors.getIdProducte();
        const idsProducteColor = producteNavegacioColors.getActiveColorIds();
        form[0].id_producte.value = idProducte;
        form[0].ids_producte_color.value = idsProducteColor.join(',');

        if (jqBt.data('is-personalitzable')) {
            const textPersonalitzacio = getPromptPersonalitzacioText(
                jqBt.data('personalitzable-message'),
                jqBt.data('personalitzable-length-error-message'));
            if (textPersonalitzacio !== null) {
                form[0].personalitzacio.value = textPersonalitzacio;
            } else {
                return;
            }
        }

        form.submit();
    });
}

// En el document ready
$(function() {
    initBabylistButton();
    // ... resto del código
});

// Exportar la función para que esté disponible
window.initBabylistButton = initBabylistButton;

